interface URLs {
  LOCAL_URI: string;
  CDN_URI: string;
}
const defaultCdnUrl = 'https://ddzs4xvq8xxep.cloudfront.net/';

const urls: URLs = {
  LOCAL_URI: '/assets/',
  CDN_URI: import.meta.env.VITE_CDN_URL || defaultCdnUrl,
};

const forceLocalAssets = import.meta.env.VITE_LOCAL_ASSETS_ONLY === 'true';
const isDevelopment = import.meta.env.MODE === 'development';
const url: string =
  isDevelopment || forceLocalAssets ? urls.LOCAL_URI : urls.CDN_URI;

export default url;
